<div class="container-fluid">
  @if (!showErrorView) {
    @if (!isPageLoading) {
      <div class="pay_options">
        <app-header
          [paymentDetails]="paymentDetails"
          [currentActiveHeader]="currentActiveHeader"
          [activeMethod]="selectedPaymentMethod"
          (paymentMethod)="setSelectedPaymentMethodPage($event)"
        ></app-header>
      </div>
    }
    <div class="pay_content">
      <app-loading [scoped]="true"></app-loading>
      @if (!isPageLoading) {
        <div style="margin-top: -3%">
          <div class="flexed">
            @if (whiteLabelInfo) {
              <div class="img-wrapper">
                <img [src]="whiteLabelInfo?.logoUrl" alt="logo" class="logo" />
              </div>
            }
            <div class="ml-auto">
              <p class="header_amount no-margin-b">
                @if (
                  paymentInfo?.feeBearer !== "Customer" &&
                  paymentDetails?.feeBearer !== "Customer"
                ) {
                  {{ baseAmount | currency: paymentDetails?.currency }}
                }
                @if (
                  paymentInfo?.feeBearer === "Customer" ||
                  paymentDetails?.feeBearer === "Customer"
                ) {
                  {{ amountWithFees | currency: paymentDetails?.currency }}
                }
              </p>
              <p class="header_name no-margin-b">
                {{ customerName ? customerName : paymentDetails?.clientName }}
              </p>
            </div>
          </div>
          @if (
            paymentInfo?.feeBearer === "Customer" ||
            paymentDetails?.feeBearer === "Customer"
          ) {
            <p style="text-align: left" class="no-margin-b">
              <span>There is a service charge of </span>
              <span>
                {{
                  paymentDetails?.fees | currency: paymentDetails?.currency
                }}</span
              >
            </p>
          }
          <hr />
        </div>
      }
      @if (!isPageLoading) {
        <div class="display">
          <!-- <app-inter-payment
            *ngIf="isCard && paymentDetails.currency === 'USD'"
            [paymentDetails]="paymentDetails"
          ></app-inter-payment> -->
          @if (
            selectedPaymentMethod === "CARD" &&
            paymentInfo?.paymentMethodInfo?.cardEnabled
          ) {
            <app-card-data-capture
              (isMakingPayment)="checkOptionsStatus($event)"
              [paymentDetails]="paymentDetails"
              [whiteLabelInfo]="whiteLabelInfo"
            ></app-card-data-capture>
          }
          @if (selectedPaymentMethod === PaymentMethods.MGPS) {
            <app-mpgs
              (isMakingPayment)="checkOptionsStatus($event)"
              [paymentDetails]="paymentDetails"
            ></app-mpgs>
          }
          @if (
            selectedPaymentMethod === "USSD" &&
            paymentInfo?.paymentMethodInfo?.ussdEnabled
          ) {
            <app-ussd
              (isMakingPayment)="checkOptionsStatus($event)"
              [paymentDetails]="paymentDetails"
              [whiteLabelInfo]="whiteLabelInfo"
            ></app-ussd>
          }
          @if (selectedPaymentMethod === PaymentMethods.MOMO) {
            <app-momo
              (isMakingPayment)="checkOptionsStatus($event)"
              [paymentDetails]="paymentDetails"
            ></app-momo>
          }
          @if (
            selectedPaymentMethod === "ACCOUNT TRANSFER" &&
            paymentInfo?.paymentMethodInfo?.accountTransferEnabled
          ) {
            <app-bank
              (isMakingPayment)="checkOptionsStatus($event)"
              [paymentDetails]="paymentDetails"
              [paymentReference]="paymentReference"
              [whiteLabelInfo]="whiteLabelInfo"
            ></app-bank>
          }
          @if (
            selectedPaymentMethod === PaymentMethods.OPAY &&
            paymentInfo?.paymentMethodInfo?.bankAppEnabled
          ) {
            <app-opay
              [whiteLabelInfo]="whiteLabelInfo"
              [paymentDetails]="paymentDetails"
              [paymentReference]="paymentReference"
              (submitPayment)="checkOptionsStatus($event)"
            ></app-opay>
          }
          @if (
            selectedPaymentMethod === "BANK" &&
            paymentInfo?.paymentMethodInfo?.bankAppEnabled
          ) {
            <app-banks
              [whiteLabelInfo]="whiteLabelInfo"
              [paymentDetails]="paymentDetails"
              [paymentReference]="paymentReference"
            ></app-banks>
          }
          <!-- <app-qr-code *ngIf="isQr"></app-qr-code> -->
        </div>
      }
      <!-- <div class="text-center" *ngIf="isPageLoading">
      <div
        class="spinner-border spinner-border"
        style="width: 10rem; height: 10rem"
        role="status"
        >
        <span class="sr-only">Loading...</span>
      </div>
      <br /><br />
      <p style="color: black">{{ activity }}</p>
    </div> -->
    </div>
  }

  <app-error-dialog
    [visible]="channelErrorVisible"
    [message]="channelErrorMessage"
    (closed)="channelErrorVisible = false"
  ></app-error-dialog>

  @if (showErrorView) {
    <div style="margin-top: 5rem" class="flex-column align-items-center flexed">
      <div class="img_wrapper">
        <img src="../../../assets/images/404.gif" alt="" />
      </div>
      <p>{{ errorMessage }}</p>
    </div>
  }
</div>
